module.exports = __webpack_public_path__ + "img/bgs.ee66e71b.png";